import { AfterViewInit, ChangeDetectorRef, Directive, ElementRef, HostListener, ViewChild } from '@angular/core';
import { AdminActionsDirective } from '@app/main/admin/directives/admin-actions.directive';
import { AdminService } from '../admin.service';
import { IBase } from '@shared/interfaces';
import { DialogService } from '@shared/services';
import { ModuleService } from '@shared/services/module.service';

@Directive()
export class AdminItemContainerDirective extends AdminActionsDirective implements AfterViewInit {
    itemWidth: number;
    @ViewChild('itemContainer') itemContainer: ElementRef;

    constructor(
        public changeDetection: ChangeDetectorRef,
        adminService: AdminService,
        dialogService: DialogService,
        moduleService: ModuleService
    ) {
        super(adminService, dialogService, moduleService);
    }

    ngAfterViewInit() {
        this.setItemWidth();
    }

    @HostListener('window:resize') onResize() {
        this.setItemWidth();
    }

    private setItemWidth() {
        setTimeout(() => {
            const width = this.itemContainer?.nativeElement.clientWidth;
            if (window.innerWidth >= 2247) {
                this.itemWidth = (width - 130) / 5;
            } else if (window.innerWidth >= 1612) {
                this.itemWidth = (width - 110) / 4;
            } else {
                this.itemWidth = (width - 90) / 3;
            }
            this.itemWidth = this.itemWidth >= 200 ? this.itemWidth : 200;
        }, 50);
    }

    get unfilteredData(): IBase[] {
        return this.data?.filter(e => !e.filtered);
    }

    getCopy(val?: IBase[]): IBase[] {
        const items = val ? val : this._data;
        return items ? JSON.parse(JSON.stringify(items)) : null;
    }
}
